import type { QueryClient } from '@tanstack/react-query';
import { findSearchDoctor, seedPiecesFromSearchDoctor } from '@/modules/profile/utils/seedPiecesFromSearch';

export function priorDoctorData(queryClient: QueryClient, slug: string, piece: 'name' | 'expertise' | 'image' | 'centers') {
  const decode = (value: string) => { try { return decodeURIComponent(value); } catch { return value; } };
  const cached = queryClient.getQueryCache().findAll({ queryKey: ['profilePiece', piece] })
    .filter(query => typeof query.queryKey[2] === 'string' && decode(query.queryKey[2]) === decode(slug) && query.state.data != null)
    .sort((a, b) => b.state.dataUpdatedAt - a.state.dataUpdatedAt)[0];
  if (cached) return cached.state.data;
  const seed = seedPiecesFromSearchDoctor(findSearchDoctor(queryClient, slug));
  return seed[piece === 'name' ? 'fullName' : piece];
}